// extracted by mini-css-extract-plugin
export default {"root":"tfx7qJqbcqd3PoQe4F3X","itemSelector":"WhoFhhKk5iM3ZcFsbb6x"};